export enum HeaderViews {
  Map = 'Map',
  Temperature = 'Temperature',
  Humidity = 'Humidity'
}
